<template>
	<div v-if="is_logged_in"  class="home">
        
		<div class="panel panel-default drop-shadow"  style=" min-height:400px; height:auto; overflow:hidden;">
			<div class="panel-heading panel-grey text-left">
				FILES
			</div>

			<div style="padding:5px;">
				<div id="exTab2">
					<ul class="nav nav-tabs nav-bottom">
						<li>&nbsp;&nbsp;&nbsp;</li>
						<li  v-bind:class="{ active: show_section == 1 }"><a href="#" @click="show_section = 1">My Files</a></li>
						<li  v-bind:class="{ active: show_section == 2 }"><a href="#" @click="show_section = 2">Received Files</a></li>
						<li  v-bind:class="{ active: show_section == 3 }"><a href="#" @click="show_section = 3">CC&apos;ed Files</a></li>
					</ul>
				</div>
	
				<div class="no-padding">
					<MyFiles    v-show="show_section == 1"></MyFiles>
					<RcvFiles   v-show="show_section == 2"></RcvFiles>
					<CcFiles    v-show="show_section == 3"></CcFiles>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import MyFiles   from "@/components/files_owned.vue";
	import RcvFiles  from "@/components/files_received.vue";
	import CcFiles   from "@/components/files_copied.vue";

    export default {
        components: {
			MyFiles,
			RcvFiles,
			CcFiles,
        },

        data() {
            return {
				show_section: 1,
            };
        },

        computed: {
        },
		
		created() {
		},

        mounted() {
			if (this.is_logged_in()) {
				//
			}
        },
		
        methods: {
			is_logged_in() {
				var status     = false;
				this.api_token = localStorage.getItem('api_token');
				
				if (this.api_token  &&  this.api_token.length == 64) {
					status = true;
				}
					
				return status;
			},
        }
    };
</script>
